import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { ApplicationConfig, importProvidersFrom } from '@angular/core';
import { provideClientHydration } from '@angular/platform-browser';
import { provideRouter } from '@angular/router';
import { IonicModule } from '@ionic/angular';
import { IonicStorageModule } from '@ionic/storage-angular';
import { agritourismAppRoutes } from './app.routes';
import { AgritourismAuthGuard } from './auth/auth.guard';
import { AgritourismCognitoService } from './auth/cognito.service';
import { AgritourismJwtInterceptor } from './auth/jwt.interceptor';
import { UnauthenticatedErrorInterceptor } from './auth/unauthenticated-error.interceptor';
import { AgritourismService } from './services/agritourism.service';
import { AgritourismAlertService } from './services/alert.service';
import { AgritourismLocalStorageService } from './services/local-storage.service';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const providers: any[] = [
  provideRouter(agritourismAppRoutes),
  provideClientHydration(),
  importProvidersFrom(IonicModule.forRoot(), IonicStorageModule.forRoot(), HttpClientModule),
  { provide: HTTP_INTERCEPTORS, useClass: AgritourismJwtInterceptor, multi: true },
  {
    provide: HTTP_INTERCEPTORS,
    useClass: UnauthenticatedErrorInterceptor,
    multi: true,
  },
  AgritourismAuthGuard,
  AgritourismCognitoService,
  AgritourismService,
  AgritourismAlertService,
  AgritourismLocalStorageService,
];

export const appConfig: ApplicationConfig = {
  providers,
};
